import { Button } from '@material-ui/core';
import React, { useCallback } from 'react';
import { Privilege } from '../../api';
import useHasPrivilege from '../Util/useHasPrivilege';
import { EvictionStatus } from './Label/sessionLabelOverviewReducer';
import { fetchPatch } from '../Util/fetchAPI';
import { useSnackbar } from 'notistack';
import styled from 'styled-components';

type Props = {
  runId: string;
  nextState: EvictionStatus;
};

const SessionRunEvict = (props: Props) => {
  const hasExportPermission = useHasPrivilege(Privilege.ExportData);
  const isEvicting: boolean = props.nextState === EvictionStatus.Evicting;
  const { enqueueSnackbar } = useSnackbar();

  const onEvict = useCallback(() => {
    fetchPatch('/gateway/label-assistant-v2/api/v1/label/run/' + props.runId + '/status', { eviction: { status: props.nextState } } );
    enqueueSnackbar(isEvicting ? 'Evicting data...' : 'Loading data...', {
      variant: 'info',
      autoHideDuration: 5000,
    });
  }, [props, enqueueSnackbar, isEvicting]);

  return hasExportPermission ? (
    <Container>
      <Button variant="contained" style={{backgroundColor: isEvicting ? "#900" : "#090", color: "#fff", }} onClick={onEvict}>
        { isEvicting ? "Evict data" : "Load data" }
      </Button>
    </Container>
    ) : (
      <div />
    );
};

const Container = styled.div`
  border-top: 1px solid darkgray;
  padding-top: 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;

export default SessionRunEvict;
